module.exports = __webpack_public_path__ + "static/bridal-bouquet-aced08a59ca5a568c71a4ce3c29dce46.jpg";